import { PlaceOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';

type ISelectedAddressProps = {
  onRemove?: () => void;
  address: string;
};

export const SelectedAddress: React.FC<ISelectedAddressProps> = ({
  onRemove,
  address,
}) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'info.main',
      borderRadius: 1,
      px: 2,
      py: 1.325,
    }}
    bgcolor="#F5FBFE"
    display="flex"
    alignItems="center"
    justifyContent="space-between"
  >
    <Box display="flex">
      <PlaceOutlined fontSize="small" />
      <Typography variant="body2" sx={{ ml: 1 }}>
        {address}
      </Typography>
    </Box>

    {onRemove && (
      <IconButton aria-label="close" onClick={onRemove} size="small">
        <CloseIcon fontSize="small" />
      </IconButton>
    )}
  </Box>
);
